export const returnDataRecord = (service) => {
    const dataAttention = {
        anamnesis: "",
        dateControl: "",
        days: "",
        derivation: [],
        descriptionDerivation: "",
        diagnosis: "",
        diagnosisRelated: [],
        fechaFinReposo: "",
        fechaInicioReposo: "",
        folioLicencia: "",
        idLicencia: "",
        medicalLicence: false,
        medicalOrderDetail: "",
        medicalOrders: [],
        medicalProcedures: "",
        medicines: [],
        past: "",
        physicalExam: "",
        reasonConsultation: "",
        resume: "",
        tratNdias: "",
        urgencyReferral: false,
        urgencyDescription: "",
        suicideRisk: false,
        suicideRiskDescription: "",
        ratingScale: [],
        riskScore: null
    }

    if (service.imc) {
        dataAttention.imc = "";
        dataAttention.nutritionalIndication = "";
        dataAttention.patientHeight = "";
        dataAttention.patientWeight = "";
    }

    return { ...dataAttention };
}